import React from "react"
import Button from "../../components/Button"

import Layout from "../../components/layout"
import Project from "../../components/portfolio/Project"
import Seo from "../../components/seo"

import LandscapesFirst from "../../images/landscapes-first.webp"
import LandscapesSecond from "../../images/landscapes-second.webp"
import LandscapesThird from "../../images/landscapes-third.webp"
import LandscapesFourth from "../../images/landscapes-fourth.webp"
import LandscapesFifth from "../../images/landscapes-fifth.webp"
import LandscapesSixth from "../../images/landscapes-sixth.webp"

const images = [
  {
    img: LandscapesFirst,
    title: "Island",
    text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur",
  },
  {
    img: LandscapesSecond,
    title: "Island",
    text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur",
  },
  {
    img: LandscapesThird,
    title: "Island",
    text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur",
  },
  {
    img: LandscapesFourth,
    title: "Island",
    text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur",
  },
  {
    img: LandscapesFifth,
    title: "Island",
    text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur",
  },
  {
    img: LandscapesSixth,
    title: "Island",
    text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur",
  },
]

const Landscapes = () => {
  return (
    <Layout>
      <Seo title="landscapes" />
      <div className="desktop pb-20 mt-16 md:mt-[200px] mx-3 md:mx-auto">
        <div className="flex flex-col items-center text-center text-black mb-20 md:mb-32 lg:mb-60">
          <h1 className="m-0 mb-[36px] font-playfair font-black text-5xl md:text-[70px]">
            Landscapes
          </h1>
          <span className="font-ubuntu font-light text-[16px] md:text-lg md:w-10/12 lg:w-[66%] lg:text-[16px]">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur.
          </span>
        </div>

        <section className="flex flex-col items-center">
          <div className="grid gap-[20px] mb-[41px] lg:grid-cols-2">
            {images.map((image, idx) => {
              return <Project {...image} key={`${idx}_${image.img}`} />
            })}
          </div>
          <Button color="transparent" size="xs">
            Load more
          </Button>
        </section>
      </div>
    </Layout>
  )
}

export default Landscapes
